<template>
  <div>   
    <!--Header-->
    <div>
      <main-header />
    </div>
    <!--Search panel-->
    <div class="section">
      <search-and-filter />
    </div>
    <!--Marketplace and Quotation panel-->
    <div class="section">
      <div class="columns">
        <div class="column">
          <marketplace />
        </div>
        <!-- <div class="column">
          <h4>Quotation-placeholder</h4>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Marketplace from "./Marketplace";
import SearchAndFilter from "./SearchAndFilter";
import MainHeader from "./MainHeader";

export default {
  name: "Store",
  components: { Marketplace, SearchAndFilter, MainHeader },
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>